
export function initMobileMenu() {
  const mobileMenuToggler  = document.querySelector('.js-toggleMobileMenu');

  mobileMenuToggler.addEventListener('click', (e) => {
    e.preventDefault();
    const mobileMenu = document.querySelector('.js-mobileMenuContainer');
    mobileMenu.classList.toggle('l-mobile');
    const mobileMenuTogglerButton  = document.querySelector('.js-toggleMobileMenu > i');
    mobileMenuTogglerButton.classList.toggle('fa-bars');
    mobileMenuTogglerButton.classList.toggle('toggleMenuOpen');
    const mobileMenuHeader  = document.querySelector('.pageContainer .pageHeader');
    mobileMenuHeader.classList.toggle('pageHeaderMobileOn');
  });
}
